<template>
  <div class="content ">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <card class="strpied-tabled-with-hover" body-classes="table-full-width table-responsive">
            <template slot="header">
              <div class="row">
                <div class="col-8">
                  <h4 class="card-title">Müşterilerin Mail Adresleri</h4>
                  <p class="card-category">Müşterilerinize ait mail hesapları aşağıdadır.</p>
                </div>
                <div class="col-4">
                  <div class="row">
                    <div class="col">
                      <button @click="excellModalLaunch()" class="btn btn-primary btn-fill float-right">
                        Excellden Aktar
                      </button>



                      <div class="modal fade show bg-gray" id="exampleModalLive" tabindex="-1"
                        aria-labelledby="exampleModalLiveLabel"
                        :style="excellModal.isOpened == true ? 'display: block;' : 'display: none;'" aria-modal="true"
                        role="dialog">
                        <div class="modal-dialog">
                          <div class="modal-content">
                            <div class="modal-header">
                              <h5 class="modal-title" id="exampleModalLiveLabel">Excell ile Toplu Mail Aktarma</h5>
                              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">×</span>
                              </button>
                            </div>

                            <div class="modal-body">
                              <label>Excell Dosyası Seç</label>

                              <div class="input-group mb-3">

                                <div class="custom-file">
                                  <input type="file" class="custom-file-input" @change="onFileChange">
                                  <label class="custom-file-label" for="inputGroupFile01">{{ excellModal.fileName
                                  }}</label>
                                </div>
                              </div>
                              <div>
                                {{ excellModal.payload.mailList.length }} adet mail tespit edildi.
                              </div>
                              <label>Grup Seçimi</label>


                              <div class="row" v-for="group of Object.values(mailGroups)" :key="group._id">
                                <div class="col">
                                  <label>{{ group.title }} <input type="checkbox"
                                      aria-label="Checkbox for following text input" @click="selectGroupModal(group._id)"
                                      :checked="excellModal.payload.mailGroup.includes(group._id)"
                                      :disabled="group.isSpecialGroup && isSpecialGroupSelected && selectedSpecialGroup._id !== group._id">
                                  </label>



                                </div>
                              </div>

                            </div>
                            <div class="modal-footer">

                              <button type="button" class="btn btn-secondary" @click="excellModalLaunch()"
                                data-dismiss="modal">Kapat</button>
                              <button type="button" class="btn btn-primary" @click="postModal()">Aktar</button>
                            </div>
                          </div>
                        </div>
                      </div>


                    </div>
                    <div class="col">
                      <button class="btn btn-success btn-fill  mr-3" @click="createNew()">
                        Yeni Oluştur
                      </button>
                    </div>

                  </div>
                </div>

              </div>



              <div class="row p-3">
                <div class="btn-group" role="group" aria-label="Basic example">
                  <button type="button" class="btn btn-fill ml-2" @click="selectGroup(group._id)"
                    :class="selectedGroups.includes(group._id) ? 'btn-success' : ''"
                    v-for="group of Object.values(mailGroups)" :key="group._id">{{ group.title }} ({{ group.countRecord }})</button>

                </div>
              </div>
              <div class="row">
                <div class="col-3 ml-2">
                  <input class="form-control form-control-lg" @change="getMails()" v-model="queryText" type="text"
                    placeholder="Arama">
                </div>

              </div>


            </template>


            <table class="table table-hover table-striped">
              <thead>
                <slot name="columns">
                  <tr>
                    <th v-for="column in tableColumns" :key="column">{{ column }}</th>
                  </tr>
                </slot>
              </thead>
              <tbody>
                <tr v-for="(item) in tableData" :key="item._id">
                  <slot :row="item">
                    <td>{{ item.mail }}</td>
                    <td>{{ item.companyName }}</td>
                    <td>{{ item.mailGroup.reduce((p, n) => p += mailGroups[n] ? mailGroups[n].title + ', ' : '-',
                      '').slice(0, -2) }}</td>
                    <td>{{ item.isActive }}</td>
                    <td>{{ item.isSubscribed }}</td>
                    <td @click="openDeleteModal(item)"><button><i class="nc-icon nc-simple-remove"></i></button></td>
                    <td @click="editMail(item._id)"><button><i class="nc-icon nc-settings-tool-66"></i></button></td>
                  </slot>
                </tr>
              </tbody>
            </table>
            <nav aria-label="...">
              <ul class="pagination text-center" style="margin-left: 45%;">

                <li class="page-item"   
                  v-for="i of (pagination.totalPages > 1 ? Array.from(Array(pagination.totalPages).keys()).slice(pagination.currentPage > 3 ? pagination.currentPage - 3 : 0, pagination.currentPage + pagination.layOutMax) : [0])"
                  :class="pagination.currentPage == i + 1 ? 'active' : ''" @click="paginationGet(i + 1)"
                  :key="i"
                  
                  ><a
                    class="page-link">{{ i + 1 }}</a></li>



              </ul>
            </nav>
          </card>

        </div>


        <div class="modal fade show bg-gray" tabindex="-1"
          :style="deleteModal.isOpened == true ? 'display: block;' : 'display: none;'" aria-modal="true" role="dialog">
          <div class="modal-dialog" v-if="deleteModal.mail">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLiveLabel">Maili silmek istediğinize emin misiniz?</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="deleteModal = false">
                  <span aria-hidden="true">×</span>
                </button>
              </div>

              <div class="modal-body">
                <label><strong>Mail:</strong> {{ deleteModal.mail.mail }}</label><br>
                <label><strong>Şirket:</strong> {{ deleteModal.mail.companyName }}</label><br>
                <label><strong>Grup:</strong> {{ deleteModal.mail.mailGroup.reduce((p, n) => p += mailGroups[n] ?
                  mailGroups[n].title + ', ' : '-',
                  '').slice(0, -2) }}</label><br>

              </div>
              <div class="modal-footer">

                <button type="button" @click="openDeleteModal(null)" class="btn btn-secondary"
                  data-dismiss="modal">Kapat</button>
                <button type="button" @click="deleteMail(deleteModal.mail._id)" class="btn btn-primary">Sil!</button>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
import Card from 'src/components/Cards/Card.vue'
import CollectionService from "../../services/collection.service.js";
import readXlsxFile from 'read-excel-file';


const tableColumns = ['Mail', 'Şirket', 'Grup', 'Aktif mi?', 'Abone Listesinde Mi?']
export default {
  components: {
    Card
  },
  data() {
    return {
      tableColumns,
      tableData: [],
      mailGroups: {},
      pagination: {
        currentPage: 1,
        totalPages: 0,
        itemsPerPage: 10,
        layOutMax: 3
      },
      selectedGroups: [],
      queryText: '',
      fromMails: [],
      excellModal: {
        isOpened: false,
        fileName: "Dosya Seç",
        payload: {
          mailGroup: [],
          mailList: []

        }
      },
      deleteModal: {
        isOpened: false,
        mail: null
      },
      isSpecialGroupSelected: false,
      selectedSpecialGroup: null,
    }
  },
  mounted() {
    this.getMailGroups();
    this.getFromMails();

  },
  methods: {
    paginationGet(i) {
      this.pagination.currentPage = Number(i);
      this.getMails();
      window.scroll({ top: 0, behavior: "smooth" })
    },
    getFromMails() {
      CollectionService.getCollection('frommail').then((res) => {
        if (res.success == true) {
          this.fromMails = res.fromMails;
        } else {
          console.log('error');
        }
      })
    },
    getMails() {
      let q = { mailGroup: { '$in': this.selectedGroups }, mail: { '$regex': this.queryText, $options: 'i' } };
      let p = {};
      let o = { skip: (this.pagination.currentPage - 1) * this.pagination.itemsPerPage, limit: this.pagination.itemsPerPage, sort: { createdAt: -1 } }



      if (this.selectedGroups.length == 0) {
        delete q.mailGroup;
      }
      let query = `q=${JSON.stringify(q)}&p=${JSON.stringify(p)}&o=${JSON.stringify(o)}`

      CollectionService.getCollection('mail', query).then((res) => {
        if (res.success == true) {
          this.tableData = res.mails;
          this.pagination.totalPages = Math.ceil(res.count / this.pagination.itemsPerPage);

        } else {
          console.log('error');
        }
      })
    },
    excellModalLaunch() {
      this.excellModal.isOpened = !this.excellModal.isOpened
    },
    getMailGroups() {
      CollectionService.getCollection('mailGroup').then((res) => {
        if (res.success == true) {
          this.mailGroups = res.mailGroups.reduce((p, n) => ({ ...p, [n._id]: n }), {});
          this.selectedGroups = Object.keys(this.mailGroups);
          this.getMails();
        } else {
          console.log('error');
        }
      })
    },
    deleteMail(_id) {
      CollectionService.deleteItem('mail', _id).then((res) => {
        this.notifyVue('bottom', 'right', 'danger', ` ${this.deleteModal.mail.mail} maili silindi.`)
        this.deleteModal.isOpened = false;
        this.deleteModal.mail = null;
        this.getMails();
      })
    },
    openDeleteModal(mail) {
      this.deleteModal.isOpened = !this.deleteModal.isOpened
      this.deleteModal.mail = mail;
    },
    editMail(_id) {
      this.$router.push(`/admin/mails/${_id}`);
    },
    createNew() {
      this.$router.push(`/admin/mails/create`);
    },
    selectGroup(_id) {
      if (!this.selectedGroups.includes(_id)) {
        this.selectedGroups.push(_id);
      } else {
        this.selectedGroups = this.selectedGroups.filter(x => _id != x)
      }
      this.getMails();
    },
    selectGroupModal(_id) {
      const group = this.mailGroups[_id];

      if (!this.excellModal.payload.mailGroup.includes(_id)) {
        this.excellModal.payload.mailGroup.push(_id);
        if (group.isSpecialGroup) {
          this.isSpecialGroupSelected = true;
          this.selectedSpecialGroup = group;
        }
      } else {
        this.excellModal.payload.mailGroup = this.excellModal.payload.mailGroup.filter(x => x != _id)
        if (group.isSpecialGroup) {
          this.isSpecialGroupSelected = false;
          this.selectedSpecialGroup = null;
        }
      }
    },
    onFileChange(event) {

      let xlsxfile = event.target.files ? event.target.files[0] : null;
      if (xlsxfile) {
        this.excellModal.fileName = xlsxfile.name;
      }
      readXlsxFile(xlsxfile).then((rows) => {
        this.excellModal.payload.mailList = rows.filter(x => x[0] && typeof x[0] == 'string' && x[0].length > 0 && x[0].includes('@')).map(x => x[0]);
      })
    },
    postModal() {
      CollectionService.postWidthAuth('mail/bulk', this.excellModal.payload).then((res) => {
        if (res.success == true) {
          this.notifyVue('bottom', 'right', 'success', res.bulkInsertResult + ' mail aktarıldı.')
          this.excellModalLaunch();
          this.getMailGroups();
        } else {
          this.notifyVue('bottom', 'right', 'danger', res.body)
          this.getMailGroups();
        }
      }).catch(err => {
        this.notifyVue('bottom', 'right', 'danger', err)
      })
    },
    notifyVue(verticalAlign, horizontalAlign, type, message) {
      this.$notifications.notify(
        {
          message: JSON.stringify(message),
          icon: '',
          horizontalAlign: horizontalAlign,
          verticalAlign: verticalAlign,
          type
        })
    },
  }
}
</script>
<style></style>